var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1801 8.495C18.4182 9.71259 18.3729 10.9687 18.0476 12.1659C17.7223 13.3632 17.1258 14.4695 16.3042 15.3992C14.5834 17.3242 12.3567 17.5 10.0001 17.5C7.64338 17.5 5.40922 17.3242 3.69339 15.3992C2.87261 14.4691 2.27676 13.3626 1.95193 12.1655C1.62709 10.9683 1.58197 9.71241 1.82005 8.495C2.93988 8.24254 4.10776 8.30528 5.19409 8.67627C6.28043 9.04725 7.24273 9.71197 7.97422 10.5967C9.00792 11.7572 9.70798 13.176 10.0001 14.7025C10.2887 13.176 10.9869 11.7568 12.0201 10.5967C12.7529 9.71201 13.7162 9.04743 14.8035 8.67649C15.8907 8.30555 17.0593 8.24274 18.1801 8.495ZM10.0001 2.5C8.36548 3.65324 7.24406 5.39753 6.87339 7.36333C7.75603 7.83994 8.54943 8.46586 9.21839 9.21333C9.49875 9.52661 9.75979 9.85667 10.0001 10.2017C10.2396 9.85629 10.5 9.52595 10.7801 9.2125C11.4505 8.4639 12.2456 7.83713 13.1301 7.36C12.7584 5.39462 11.6357 3.65134 10.0001 2.5Z",
    fill: "#ABD373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendGreen);
export default __webpack_public_path__ + "static/media/trendGreen.7b75538d5060ed99501b27477302655e.svg";
export { ForwardRef as ReactComponent };